import * as React from 'react';
import IEditor from './IEditor';
import EditorViewState from '../store/schema/EditorViewState';
import updateContent from '../actions/updateContent';

const styles = require('./ReactEditor.scss');
const classnames = require('classnames');

export interface BareContentEditableDivEditorProps {
    viewState: EditorViewState;
    className: ClassValue;
}

export default class BareContentEditableDivEditor
    extends React.Component<BareContentEditableDivEditorProps, {}>
    implements IEditor<BareContentEditableDivEditorProps, {}> {
    private contentEditableRef: React.RefObject<HTMLDivElement> = React.createRef();

    public focus(): void {
        this.contentEditableRef.current && this.contentEditableRef.current.focus();
    }

    public getContent(): string {
        return this.contentEditableRef.current && this.contentEditableRef.current.innerHTML;
    }

    shouldComponentUpdate() {
        // never re-render (keep transient state in the editor)
        return false;
    }

    private onBlur = () => {
        updateContent(this.props.viewState, this.getContent(), false);
    };

    render() {
        return (
            // Reviewed with @ravijai. This is a potential opening for an XSS if a user copy pastes a script into
            // their editor and then mounts it here (the same XSS avenue as ReadingPane local lie).
            //
            // Because this feature is SDF-only and not intended for actual users, this usage is considered
            // acceptable.
            //
            // tslint:disable-next-line:react-no-dangerous-html
            <div
                contentEditable
                className={classnames(styles.editor, this.props.className)}
                onBlur={this.onBlur}
                ref={this.contentEditableRef}
                dangerouslySetInnerHTML={{
                    __html: this.props.viewState.content,
                }}
            />
        );
    }
}
